import { S, ui, save } from "../../app/store.js";
import { V } from "../../app/pages.js";
import { can, emp, uname } from "../../services/access.js";
import { today, fmtD } from "../../domain/dates.js";
import { esc, peso } from "../../domain/format.js";
import { panel, csvBtn, ssn } from "../../components/ui.js";
import { sitePicker } from "../sites/components.js";
import { inSite, proj, siteCode } from "../sites/model.js";
import { createWorkLog, approveWorkLog } from "../../domain/work-logs.js";
import { syncDraft } from "../deployments/page.js";
import { log } from "../../services/audit.js";
import { render } from "../../app/shell.js";
import { activateCreation, finishCreation } from "../../components/creation-flow.js";
import { attendancePanel } from "../hrm/foundation.js";

function workLogForm() {
  const d = S.deployments.find((d) => d.id === ui.logDeployment),
    deps = S.deployments.filter(
      (d) =>
        d.status === "ACTIVE" &&
        inSite(d.project) &&
        (!ui.logProject ||
          ui.logProject === "ALL" ||
          d.project === ui.logProject),
    );
  return `<form id="work-log-form" class="work-log-form"><div class="panel-h"><div><h2>Record daily work</h2><p class="muted small">Attendance and output belong to a specific worker’s project deployment.</p></div></div><div class="form"><label class="wide">Personnel deployment<select id="work-log-deployment" name="deployment" required><option value="">Choose worker and project</option>${deps.map((dep) => `<option value="${dep.id}"${d?.id === dep.id ? " selected" : ""}>${esc(emp(dep.emp)?.name)} · ${esc(dep.project)} · ${esc(siteCode(proj(dep.project)))} · ${dep.type === "PIECE" ? "Piece rate" : "Daily rate"}</option>`).join("")}</select></label><label>Work date<input name="date" id="work-log-date" type="date" value="${esc(ui.logDate || today())}" min="${esc(d?.from || "")}" max="${esc(d?.to && d.to < today() ? d.to : today())}" required></label><label>Regular hours<input name="hours" type="number" min="0.001" max="8" step="0.001" value="8" required></label><label>Completed ${esc(d?.unit || "units")}<input name="units" type="number" min="0" step="0.001" value="0"${d?.type !== "PIECE" ? " disabled" : ""}></label><label>Overtime hours<input name="ot" type="number" min="0" max="16" step="0.001" value="0"></label><label>Night hours<input name="night" type="number" min="0" max="24" step="0.001" value="0"></label><label>Night hours within overtime<input name="nightOT" type="number" min="0" max="16" step="0.001" value="0"></label><label class="wide">Task / output notes<input name="note" maxlength="1000" placeholder="Work completed, location and reference"></label></div>${d ? `<p class="note">${d.type === "PIECE" ? `Piece-rate work · ${esc(d.unit)}${can("hr.salary") || can("dep.manage") ? ` · ${peso(d.rate)} per unit` : ""}. Approved quantity is used for pay and billing.` : "Daily-rate work uses approved hours and the applicable wage floor."} A different deployment manager must approve the log.</p>` : ""}${ui.logError ? `<p class="err" role="alert">${esc(ui.logError)}</p>` : ""}<div class="row"><button class="pri" type="submit"${d ? "" : " disabled"}>Submit for approval</button></div></form>`;
}
V.worklogs = () => {
  const project = ui.logProject || "ALL",
    status = ui.logStatus || "ALL",
    worker = ui.logWorker || "ALL",
    projects = S.projects.filter((p) => inSite(p.code)),
    deps = S.deployments.filter(
      (d) => inSite(d.project) && (project === "ALL" || d.project === project),
    ),
    people = [...new Set(deps.map((d) => d.emp))],
    logs = S.workLogs
      .filter(
        (l) =>
          inSite(l.project) &&
          (project === "ALL" || l.project === project) &&
          (status === "ALL" || l.status === status) &&
          (worker === "ALL" || l.emp === worker),
      )
      .sort((a, b) => b.date.localeCompare(a.date) || a.id.localeCompare(b.id)),
    pending = logs.filter((l) => l.status === "PENDING").length;
  return `<div class="form">${sitePicker()}<label>Project<select id="work-log-project"><option value="ALL">ALL · All projects</option>${projects.map((p) => `<option value="${p.code}"${p.code === project ? " selected" : ""}>${esc(p.code)} · ${esc(p.name)}</option>`).join("")}</select></label><label>Personnel<select id="work-log-worker"><option value="ALL">ALL · All personnel</option>${people.map((id) => `<option value="${id}"${id === worker ? " selected" : ""}>${esc(emp(id)?.name)}</option>`).join("")}</select></label><label>Status<select id="work-log-status">${["ALL", "PENDING", "APPROVED", "REJECTED"].map((x) => `<option${x === status ? " selected" : ""}>${x}</option>`).join("")}</select></label></div>
 <div class="kpis"><div class="kpi"><span class="lbl">Assigned personnel</span><span class="v">${people.length}</span></div><div class="kpi"><span class="lbl">Pending logs</span><span class="v">${pending}</span></div><div class="kpi"><span class="lbl">Approved logs</span><span class="v">${logs.filter((l) => l.status === "APPROVED").length}</span></div></div>
 ${can("dep.log") ? panel("Daily work log", "Record hours for daily-rate and piece-rate personnel. Record actual output for piece-rate deployments.", "", workLogForm()) : ""}
 ${panel(
   "Personnel by project",
   "A worker can have multiple deployments. Logged regular hours cannot exceed eight across all projects in a day.",
   "",
   `<div class="assignment-grid">${projects
     .filter((p) => project === "ALL" || p.code === project)
     .map((p) => {
       const ds = deps.filter(
         (d) => d.project === p.code && d.status === "ACTIVE",
       );
       return `<section class="assignment-card"><span class="lbl">${esc(siteCode(p))}</span><h3>${esc(p.code)} · ${esc(p.name)}</h3>${ds.map((d) => `<div class="assignment-person"><div><strong>${esc(emp(d.emp)?.name)}</strong><small>${d.type === "PIECE" ? `Piece rate · ${esc(d.unit)}` : "Daily rate"}</small></div>${can("dep.log") ? `<button data-log-deployment="${d.id}">Log work</button>` : ""}</div>`).join("") || '<p class="muted small">No active personnel.</p>'}</section>`;
     })
     .join("")}</div>`,
 )}
 ${panel("Attendance & output register", `${logs.length} records · Only approved logs feed payroll`, csvBtn("t-work-logs"), `<div class="tbl"><table id="t-work-logs"><thead><tr><th>Date</th><th>Personnel</th><th>Site / project</th><th>Pay basis</th><th class="n">Hours</th><th class="n">Output</th><th class="n">OT / night</th><th>Status</th><th>Review</th></tr></thead><tbody>${logs.map((l) => `<tr><td>${fmtD(l.date)}</td><td>${esc(emp(l.emp)?.name)}<div class="small muted">Logged by ${esc(uname(l.by))}</div></td><td>${esc(l.project)}<div class="small muted">${esc(siteCode(proj(l.project)))}</div></td><td>${l.type === "PIECE" ? "Piece rate" : "Daily rate"}</td><td class="n">${l.hours}</td><td class="n">${l.type === "PIECE" ? `${l.units} ${esc(l.unit)}` : "—"}</td><td>${l.ot} / ${l.night}</td><td>${ssn(l.status)}${l.approvedBy ? `<div class="small muted">${esc(uname(l.approvedBy))}</div>` : ""}</td><td>${l.status === "PENDING" && can("dep.manage") && l.by !== ui.user ? `<div class="row"><button class="pri" data-work-review="${esc(l.id)}" data-decision="APPROVED">Approve</button><button class="ghost" data-work-review="${esc(l.id)}" data-decision="REJECTED">Reject</button></div>` : l.status === "PENDING" ? "Awaiting another reviewer" : "Locked"}</td></tr>`).join("") || '<tr><td colspan="9" class="muted">No work logs match these filters.</td></tr>'}</tbody></table></div>`)}
 ${attendancePanel()}
 `;
};
export function installWorkLogEvents() {
  document.addEventListener("change", (event) => {
    const field = event.target;
    if (field.id === "work-log-deployment") {
      ui.logDeployment = field.value;
      const date = document.getElementById("work-log-date");
      if (date) ui.logDate = date.value;
      render();
    }
    const filters = {
      "work-log-project": "logProject",
      "work-log-worker": "logWorker",
      "work-log-status": "logStatus",
    };
    if (filters[field.id]) {
      ui[filters[field.id]] = field.value;
      if (field.id === "work-log-project") {
        ui.logDeployment = "";
        ui.logWorker = "ALL";
      }
      render();
    }
  });
  document.addEventListener("click", (event) => {
    const b = event.target.closest("button");
    if (!b) return;
    if (b.dataset.logDeployment) {
      ui.logDeployment = b.dataset.logDeployment;
      ui.logError = "";
      activateCreation("work-log-form", "worklogs");
      render();
    }
    if (b.dataset.workReview) {
      if (!can("dep.manage")) return;
      try {
        approveWorkLog(S, b.dataset.workReview, ui.user, b.dataset.decision);
        syncDraft();
        log(
          "Reviewed work log",
          `${b.dataset.workReview}: ${b.dataset.decision}`,
        );
        ui.logError = "";
        save();
        render();
      } catch (e) {
        ui.logError = e.message;
        render();
      }
    }
  });
  document.addEventListener("submit", (event) => {
    if (event.target.id !== "work-log-form") return;
    event.preventDefault();
    if (!can("dep.log")) return;
    try {
      const values = Object.fromEntries(new FormData(event.target));
      createWorkLog(S, values, ui.user);
      syncDraft();
      log("Submitted work log", `${values.deployment}: ${values.date}`);
      ui.logDate = values.date;
      ui.logError = "";
      save();
      finishCreation();
      render();
    } catch (e) {
      ui.logError = e.message;
      render();
    }
  });
}
